import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/CustomerStory/CustomerStories/CustomerStories.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/CustomerStory/CustomerStoryDescription/CustomerStoryDescription.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/CustomerStory/CustomerStoryVideo/CustomerStoryVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/CustomerStory/Ratings/Ratings.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/GlobalFooter/anchorTagList.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/GlobalFooter/globalFooter.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/GlobalFooter/btf.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/app/reviews-testimonials/ReviewsTestimonials.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/GlobalFooter/globalFooterItemDropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/GlobalFooter/globalFooterRowDropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/GlobalFooter/socialFooterLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/HomePage/utils/pageLoadEvent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/Product/ProductNav/headerDesktopAndMweb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/Scroll/scroll.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["getR2d2Payload"] */ "/usr/src/app/src/utils/r2d2Payload.ts");
